<template>
  <div>
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    />
    <div class="tableWrap">
      <div class="leftButtonBox">
        <CustomButton
          type="primary"
          :permissionCode="authType.tplApprovalManage.create"
          @click="openTempApproval({ type: 'create' })"
        >
          新建审批模版
        </CustomButton>
      </div>
      <Table
        border
        :columns="columns"
        size="small"
        stripe
        :data="dataSource"
        disabled-hover
        row-key="id"
        ref="tableRef"
      ></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right">
          <Page
            show-total
            show-sizer
            :total="totalCount"
            :current="filter.pageIndex"
            :page-size="filter.pageSize"
            :page-size-opts="[10, 25, 50, 100]"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import listMixins from '@/mixins/listMixins';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import { formItems, getColumns } from './config';
import authType from '@/config/authType';
export default {
  name: 'tempApprovalManage',
  mixins: [getPermissionMixin, listMixins],
  data() {
    return {
      authType,
      formItems,
      filter: {
        pageIndex: 1,
        pageSize: 10
      },
      columns: getColumns({
        edit: this.openTempApproval,
        toggleStatus: this.toggleStatus,
        copy: this.copyRow
      }),
      isEdit: false,
      currentRowId: ''
    };
  },
  computed: {
    ...mapState('tempApprovalManage', ['totalCount', 'dataSource'])
  },
  methods: {
    ...mapActions('tempApprovalManage', [
      'getTableInfo',
      'submitStatus',
      'submitCopy'
    ]),
    openTempApproval({ type, id: currentRowId, status }) {
      this.$router.push({
        path: '/tplApproval',
        query: { type, id: currentRowId, status }
      });
    },
    copyRow({ id }) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认后将新增一条相同配置的模板',
        okText: '确认',
        loading: true,
        onOk: () => {
          this.submitCopy({ id }).then(res => {
            if (res) {
              this.resetTableInfo();
              this.$Message.success('操作成功');
              this.$Modal.remove();
            }
          });
        }
      });
    },
    toggleStatus({ id, status, statusText }) {
      this.$Modal.confirm({
        title: statusText,
        content: `确认后该审批模板${statusText}`,
        okText: `确认${statusText}`,
        loading: true,
        onOk: () => {
          this.submitStatus({ id, status }).then(res => {
            if (res) {
              this.getTableInfo({ filter: this.filter });
              this.$Message.success(`${statusText}成功`);
              this.$Modal.remove();
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less"></style>
